var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempSticla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e9b58ed1-129d-4ae0-9c4f-43aafffb3d66",
    "data-name": "coef_temp_sticla",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b0fa3bbb-934d-4e99-b504-98e061aca4f3,.b83f10c8-3ef8-4634-b9d7-25f3d87afaf8,.e13b69c5-970b-4d38-a2a6-e85b2bb480bf,.ecceb6fc-c99a-48d1-ad9b-745157842536,.ed40d62f-1b9c-4bc1-8a1a-c9fad555430b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.ed40d62f-1b9c-4bc1-8a1a-c9fad555430b{stroke-width:8px;}.ecceb6fc-c99a-48d1-ad9b-745157842536{stroke-width:3px;}.b83f10c8-3ef8-4634-b9d7-25f3d87afaf8{stroke-width:6px;}.e13b69c5-970b-4d38-a2a6-e85b2bb480bf{stroke-width:10px;}.b0fa3bbb-934d-4e99-b504-98e061aca4f3{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_sticla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b98727ee-e5f1-46c0-a81f-494ced11e91c",
    "data-name": "termostat copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ed40d62f-1b9c-4bc1-8a1a-c9fad555430b",
    d: "M36.41,158.06a19.5,19.5,0,1,1-23.85,0",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ed40d62f-1b9c-4bc1-8a1a-c9fad555430b",
    x1: 12,
    y1: 157,
    x2: 12,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    className: "ed40d62f-1b9c-4bc1-8a1a-c9fad555430b",
    x1: 35,
    y1: 157,
    x2: 35,
    y2: 114
  }), /*#__PURE__*/React.createElement("path", {
    className: "ed40d62f-1b9c-4bc1-8a1a-c9fad555430b",
    d: "M13,114.17a11.5,11.5,0,0,1,23,0",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 173.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ecceb6fc-c99a-48d1-ad9b-745157842536",
    x1: 35.42,
    y1: 124.46,
    x2: 30.54,
    y2: 124.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "ecceb6fc-c99a-48d1-ad9b-745157842536",
    x1: 35.5,
    y1: 130.5,
    x2: 30.5,
    y2: 130.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ecceb6fc-c99a-48d1-ad9b-745157842536",
    x1: 35.5,
    y1: 136.5,
    x2: 30.5,
    y2: 136.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b83f10c8-3ef8-4634-b9d7-25f3d87afaf8",
    x1: 24,
    y1: 173,
    x2: 24,
    y2: 130
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e1dfed24-42d8-479e-867f-b6a8d67a3ff4",
    "data-name": "fereastra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "e13b69c5-970b-4d38-a2a6-e85b2bb480bf",
    points: "45.25 175 194 175 194 5 24 5 24 100"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b0fa3bbb-934d-4e99-b504-98e061aca4f3",
    x1: 163,
    y1: 14,
    x2: 184.5,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b0fa3bbb-934d-4e99-b504-98e061aca4f3",
    x1: 137,
    y1: 15,
    x2: 183.5,
    y2: 61.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempSticla);
export default __webpack_public_path__ + "static/media/coef_temp_sticla.189bcf19fd4799411cb743b0f908349f.svg";
export { ForwardRef as ReactComponent };